// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Jotai from "jotai";
import * as JsxRuntime from "react/jsx-runtime";
import * as JotaiAtoms$OrcaPaymentPage from "../Utilities/JotaiAtoms.bs.js";
import * as CommonCardFieldHooks$OrcaPaymentPage from "./CommonCardFieldHooks.bs.js";

function SecureCardNumberField(props) {
  let loggerState = Jotai.useAtomValue(JotaiAtoms$OrcaPaymentPage.loggerAtom);
  let state = CommonCardFieldHooks$OrcaPaymentPage.useCardNumberField(loggerState, true, undefined);
  return JsxRuntime.jsx(CommonCardFieldHooks$OrcaPaymentPage.RenderCardNumber.make, {
    state: state
  });
}

let make = SecureCardNumberField;

export {
  make,
}
/* jotai Not a pure module */
